import httpClient from "Api/httpClient";

const END_POINT = "/notes";

const getNotes = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body });
};

const getNote = (note_id) => {
    if (!note_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + note_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printNote = (note_id) => {
    if (!note_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?note_id=" + note_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createNotes = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateNotes = (payload, note_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + note_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteNotes = (note_id) => {
    const DELETE_END_POINT = END_POINT + "/" + note_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

// new note endpoints

const createModuleNote = (payload, module_id) => {
    let body = "";
    let module = payload.body.module;
    delete payload.body.module;
    if (payload.body) body = JSON.stringify(payload.body);
    const CREATE_END_POINT = module + "/" + module_id + "/notes";
    return httpClient.post(CREATE_END_POINT, body);
};

const patchModuleNote = (payload, note_id, module_id) => {
    let body = "";
    let module = payload.body.module;
    delete payload.body.module;
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = module + "/" + module_id + "/notes/" + note_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteModuleNote = (payload, note_id, module_id) => {
    let module = payload.body.module;
    delete payload.body.module;
    const DELETE_END_POINT = module + "/" + module_id + "/notes/" + note_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getNotes, getNote, printNote, createNotes, updateNotes, deleteNotes, patchModuleNote, deleteModuleNote, createModuleNote };
